'use strict';

var client = require('@apollo/client');

function createFormSubmissionQuery({ mutationName, formValues }) {
    // Prepare the arguments for the mutation
    const argsStr = JSON.stringify(formValues, (_key, value)=>value != null ? value : null)// Remove the quotes around keys
    .replace(/"([^"]+)":/g, '$1:')// trim the first and last curly braces
    .slice(1, -1);
    const str = client.gql(`
      mutation submitForm {
        submission: ${mutationName}(${argsStr}) {
          uid
        }
      }
    `);
    return str;
}

module.exports = createFormSubmissionQuery;
